/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import { assert, geomHelper, mergeDescriptors, sourceContainer, vectorSource } from '../core';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import Cluster from 'ol/source/cluster';
import { Observable as Observable$1 } from 'rxjs/Observable';
import { interval as interval$1 } from 'rxjs/observable/interval';
import { first as first$1 } from 'rxjs/operator/first';
import { map as map$1 } from 'rxjs/operator/map';
import { skipWhile as skipWhile$1 } from 'rxjs/operator/skipWhile';
import { toPromise as toPromise$1 } from 'rxjs/operator/toPromise';

var Builder = function () {
  function Builder() {
    _classCallCheck(this, Builder);
  }

  _createClass(Builder, [{
    key: 'getSource',

    /**
     * @return {ol.source.Vector|undefined}
     */
    value: function getSource() {
      return this.source;
    }
    /**
     * @param {ol.source.Vector|undefined} value
     * @returns {Builder}
     */

  }, {
    key: 'setSource',
    value: function setSource(value) {
      this.source = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setAttributions',
    value: function setAttributions(value) {
      this.attributions = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setDistance',
    value: function setDistance(value) {
      this.distance = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setGeometryFunction',
    value: function setGeometryFunction(value) {
      this.geometryFunction = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setLogo',
    value: function setLogo(value) {
      this.logo = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setProjection',
    value: function setProjection(value) {
      this.projection = value;
      return this;
    }

    /**
     * @param value
     * @returns {Builder}
     */

  }, {
    key: 'setWrapX',
    value: function setWrapX(value) {
      this.wrapX = value;
      return this;
    }

    /**
     * @param key
     * @param value
     * @return {void}
     */

  }, {
    key: 'set',
    value: function set(key, value) {
      this.values || (this.values = {});
      this.values[key] = value;
    }

    /**
     * @return {ol.source.Cluster}
     */

  }, {
    key: 'build',
    value: function build() {
      assert.ok(this.source, 'source is provided');

      var source = new Cluster({
        attributions: this.attributions,
        distance: this.distance,
        geometryFunction: this.geometryFunction,
        logo: this.logo,
        projection: this.projection,
        source: this.source,
        wrapX: this.wrapX
      });
      source.setProperties(this.values);

      return source;
    }

    /**
     * @return {Promise<ol.source.Cluster>}
     */

  }, {
    key: 'promise',
    value: function promise() {
      var _context,
          _this = this;

      return (_context = (_context = (_context = (_context = interval$1.call(Observable$1, 100), skipWhile$1).call(_context, function () {
        return !_this.source;
      }), first$1).call(_context), map$1).call(_context, this.build.bind(this)), toPromise$1).call(_context);
    }
  }]);

  return Builder;
}();

var props = {
  distance: {
    type: Number,
    default: 20
  },
  /**
   * Geometry function factory
   * @type {function(): (function(f: ol.Feature): ol.geom.SimpleGeometry|undefined)} geomFuncFactory
   */
  geomFuncFactory: {
    type: Function,
    default: defaultGeomFuncFactory
  }
};

var computed = {
  geomFunc: function geomFunc() {
    return this.geomFuncFactory();
  }
};

var methods = {
  /**
   * @return {Promise<ol.source.Cluster>}
   * @protected
   */
  createSource: function createSource() {
    // partial setup of ol.source.Cluster with the help of SourceBuilder class
    /**
     * @type {SourceBuilder}
     * @private
     */
    this._sourceBuilder = new Builder().setAttributions(this.attributions).setDistance(this.distance).setGeometryFunction(this.geomFunc).setLogo(this.logo).setProjection(this.projection).setWrapX(this.wrapX);

    return this._sourceBuilder.promise();
  },

  /**
   * @return {Object}
   * @protected
   */
  getServices: function getServices() {
    return mergeDescriptors(vectorSource.methods.getServices.call(this), sourceContainer.methods.getServices.call(this));
  },

  /**
   * @return {{
   *     setSource: function(ol.source.Source): void,
   *     getSource: function(): ol.source.Source
   *   }|undefined}
   * @protected
   */
  getSourceTarget: function getSourceTarget() {
    return this._sourceBuilder;
  }
};

var watch = {
  distance: function distance(value) {
    if (this.$source && value !== this.$source.getDistance()) {
      this.$source.setDistance(value);
    }
  }
};

var Source = {
  name: 'vl-source-cluster',
  mixins: [vectorSource, sourceContainer],
  props: props,
  computed: computed,
  methods: methods,
  watch: watch

  /**
   * @returns {function(f: ol.Feature): ol.geom.SimpleGeometry|undefined}
   */
};function defaultGeomFuncFactory() {
  return function (feature) {
    var geometry = feature.getGeometry();
    if (!geometry) return;

    var coordinate = geomHelper.pointOnSurface(geometry);
    if (coordinate) {
      return geomHelper.point(coordinate);
    }
  };
}

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/cluster-source/index.es.js
// module id = null
// module chunks = 